var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc" },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-vertical-demo",
          attrs: {
            collapse: _vm.collapsed,
            "collapse-transition": "",
            router: "",
            "default-active": _vm.$route.path,
            "unique-opened": "",
            "text-color": "#5D5D5D",
            "active-text-color": "#409EFF"
          }
        },
        [
          _vm._l(_vm.user.staffRole, function(menu) {
            return [
              menu.menus.length > 0
                ? _c(
                    "el-submenu",
                    { attrs: { index: menu.menuName } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("i", { staticClass: "iconfont", class: menu.icon }),
                        _c("span", [_vm._v(_vm._s(menu.menuName))])
                      ]),
                      _c(
                        "el-menu-item-group",
                        { attrs: { "background-color": "#1f2d3d" } },
                        _vm._l(menu.menus, function(chmenu) {
                          return _c(
                            "el-menu-item",
                            {
                              key: chmenu.menuId,
                              attrs: { index: chmenu.url }
                            },
                            [
                              _c("i", { class: chmenu.icon }),
                              _c("span", [_vm._v(_vm._s(chmenu.menuName))])
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              menu.menus.length == 0
                ? _c("el-menu-item", { attrs: { index: menu.url } }, [
                    _c("i", { staticClass: "iconfont", class: menu.icon }),
                    _c("span", [_vm._v(_vm._s(menu.menuName))])
                  ])
                : _vm._e()
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }